// ==============================|| PUTON ICON ||============================== //

const PutonIcon = ({ color = '#000', width = 22, className = '' }) => {
  const commonStyle = {
    fill: color,
  };

  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 800 800"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M560.7,500c-3.2-4.1-8-6.5-13.2-6.5s-10,2.4-13.2,6.5l-59,76.1c-3.9,5-4.6,11.9-1.8,17.6,2.8,5.7,8.6,9.3,15,9.3h16.6v116.9c0,9.2,7.5,16.7,16.7,16.7h51.5c9.2,0,16.7-7.5,16.7-16.7v-116.9h16.6c6.4,0,12.2-3.6,15-9.3,2.8-5.7,2.1-12.5-1.8-17.6l-59-76.1Z"
        style={commonStyle}
      />
      <path
        d="M265.7,499.8c-3.2-4.1-8-6.5-13.2-6.5s-10,2.4-13.2,6.5l-59,76.1c-3.9,5-4.6,11.9-1.8,17.6s8.6,9.3,15,9.3h16.6v116.9c0,9.2,7.5,16.7,16.7,16.7h51.5c9.2,0,16.7-7.5,16.7-16.7v-116.9h16.6c6.4,0,12.2-3.6,15-9.3,2.8-5.7,2.1-12.5-1.8-17.6l-59-76.1Z"
        style={commonStyle}
      />
      <path
        d="M720.9,91.2H85.1c-21.6,0-39.2,21-39.2,46.9v222c0,25.9,17.5,46.9,39.2,46.9h635.8c21.6,0,39.2-21,39.2-46.9v-222c0-25.9-17.5-46.9-39.2-46.9Z"
        style={commonStyle}
      />
    </svg>
  );
};

export default PutonIcon;
